<template>
    <div class="header" :style="{ 'background-color': headerConfig.bgColor ? headerConfig.bgColor : '' }">
        <div class="icon" @click="handleClickIocn">
            <i
                :class="headerConfig.headerIcon"
                :style="{ 'color': headerConfig.color ? headerConfig.color : ''}"
            ></i>
        </div>
        <h2 class="tit" :style="{ 'color': headerConfig.color ? headerConfig.color : ''}">
            {{ headerConfig.headerTitle }}
        </h2>
    </div>
</template>

<script>
export default {
    name: "publicHeader",
    props: {
        headerConfig: {
            type: Object,
            default: "",
            comment: "headerConfig",
        },
    },
    methods: {
        handleClickIocn() {
            this.$emit('handleClickIocn', "")
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 44px;
    background-color: #fff;
    z-index: 99;

    .icon {
        position: absolute;
        top: 50%;
        left: 0;
        width: 30px;
        height: 30px;
        margin-top: -15px;
        line-height: 30px;
        text-align: center;

        i {
            font-size: 24px;
            color: #424242;
        }
    }

    .tit {
        font-size: 18px;
        line-height: 44px;
        text-align: center;
        color: #424242;
    }
}
</style>